import { TOOLTIP_BUTTON_SELECTOR } from "../common/tooltips";

// Global counter for generating unique IDs
let elementId = 0;

const INPUT_SELECTOR = "input:not([type='hidden']), select, textarea";

// In Emphasis, <label> is frequently used as the form "row" element.
//
// In some cases, especially with a tooltip button, there are multiple inputs inside a single <label>.
//
// If a <label> has a tooltip button _and_ no for attribute, specify the 'for' attribute to be the ID of the first
// non-<button> input inside the <label>.
export const fixTooltipLabelFor = () => {
  document
    .querySelectorAll(TOOLTIP_BUTTON_SELECTOR)
    .forEach((tooltipButton) => {
      // Find surrounding <label>, and the first input element inside.
      const label = tooltipButton.closest("label");
      if (!label) return;
      if (label.hasAttribute("for")) return;

      const input = label.querySelector(INPUT_SELECTOR);
      if (!input) return;

      // Assign the input's ID to the label's `for` attribute, or generate one if needed.
      let targetId = input.id;
      if (!targetId) {
        targetId = `input-element-${elementId}`;
        input.setAttribute("id", targetId);
        elementId += 1;
      }
      label.setAttribute("for", targetId);
    });
};
